(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('MedicationDialogController', MedicationDialogController);

    MedicationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'Medication'];

    function MedicationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                         Medication) {
        var vm = this;

        vm.medication = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            Medication.save(vm.medication, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:medicationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
